"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShoppingBagItem = mapShoppingBagItem;
var _checkoutUtils = require("@ori/checkout-utils");
var _tsUtils = require("@ori/ts-utils");
function determineIfIsOfferItem(item, commonProps, flagLabelClass) {
  // special case for subscriptions shown in subscription section. They do not have highlighted price (PBI1204387)
  if (item.itemType === 'A') {
    return false;
  }
  // special case for back order items. They do not have highlighted price (PBI1204333)
  if (item.itemType === 'O') {
    return false;
  }
  return Boolean(commonProps.isOfferItem) || (0, _checkoutUtils.isNullableStringAGreaterThanB)(item.basicCataloguePrice, item.price) || flagLabelClass.includes('offer') || Boolean(commonProps.isDiscounted);
}
function mapShoppingBagItem(props) {
  const {
    item,
    commonProps
  } = props;
  const flag = (0, _tsUtils.isNonNullable)(item.productFlag) ? {
    label: item.productFlag.label,
    labelClass: item.productFlag.labelClass,
    tooltip: item.productFlag.tooltip
  } : undefined;
  const flagLabelClass = flag?.labelClass ?? 'no';
  const theItemIsOfferItem = determineIfIsOfferItem(item, commonProps, flagLabelClass);
  const shade = (0, _checkoutUtils.stringEmptyToUndefined)(item.colorHexCode) === undefined && (0, _checkoutUtils.stringEmptyToUndefined)(item.colorImageSrc) === undefined ? undefined : {
    hexColors: item.colorHexCode?.split(',').filter(hexCode => Boolean(hexCode)) ?? undefined,
    imageUrl: item.colorImageSrc ?? undefined,
    shadeName: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemColor)
  };

  // resetting catalogue price and basic catalogue price to undefined if itemType is back order (PBI1204333)
  const basicCataloguePrice = item.itemType === 'O' ? undefined : item.basicCataloguePrice;
  const cataloguePrice = item.itemType === 'O' ? undefined : item.price;
  return {
    basicCataloguePrice: (0, _checkoutUtils.stringEmptyToUndefined)(basicCataloguePrice),
    bp: item.bp,
    brand: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemBrand),
    bundleItems: undefined,
    buttons: undefined,
    bv: item.bv ?? undefined,
    cataloguePrice: (0, _checkoutUtils.stringEmptyToUndefined)(cataloguePrice),
    code: item.itemCode,
    flags: flag === undefined ? undefined : [flag],
    infoAddon: commonProps.infoAddon,
    image: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemImageSrc),
    isAvailable: item.isAvailable,
    isOfferColor: theItemIsOfferItem,
    isSmall: false,
    lineNumber: item.lineNumber,
    maxQuantity: item.maxQuantity,
    minQuantity: item.canBeDeleted ? item.canBeReduced ? 0 : commonProps.initialQuantity : 1,
    name: item.itemDescription,
    points: (0, _checkoutUtils.stringEmptyToUndefined)(item.points),
    priceName: commonProps.isBrandPartner ? 'cataloguePrice' : 'regularPrice',
    quantity: item.quantity,
    quantityPickerDisabled: Boolean(commonProps.isBundleItem) || Boolean(commonProps.isSubscription) || !item.isAvailable || Boolean(commonProps.isOfferItem) || !item.canBeModified,
    shade,
    showBp: commonProps.showBpGlobally,
    testId: commonProps.testId,
    totalPrice: item.totalPrice,
    translations: commonProps.basketItemTranslations,
    translationsNamespace: commonProps.basketItemTranslationsNamespace,
    type: item.itemType,
    unitPrice: (0, _checkoutUtils.stringEmptyToUndefined)(item.unitPrice),
    url: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemDetailPath)
  };
}